import { BaseComponent } from '../../../abstract/base.component';
import { Directive } from "@angular/core";
import { AppConstants } from '../../../shared/constants/app-constants';

@Directive()
export abstract class CustomerAchDirectCharge extends BaseComponent {
    // state all variables here
    protected achPaymentApiCall(postBody) {
        this.loadFlag = true;
        const url = AppConstants.BASE_URL + AppConstants.SERVICE_NAME_ACH_PAYLIANCE_DEBIT_CREDIT;
        this.dataManager.postRequest(url, postBody, 0)
            .subscribe(
                response =>{
                    this.loadFlag = false;
                    this.passResponse(response);
                },
                error => {
                    this.loadFlag = false;
                    this.networkErrorHandler(error);
                    this.passError(error.error);
                }
            )
    }

    protected abstract passError(error);
    protected abstract passResponse(response);

    protected getPermissionACHApproved(url) {
        this.dataManager.getRequest(url, 0)
            .subscribe(
                response => {
                    this.assignFlagEnableAchPayments(response);
                    this.loadFlag = false;
                },
                error => {
                    this.loadFlag = false;
                    this.networkErrorHandler(error.error);
                    this.getError(error.error);
                }
            );
    }

    protected abstract assignFlagEnableAchPayments(response);
    protected abstract getError(error);

}